import Text from '@components/Text';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useGlobalName from '@hooks/useGlobalName';
import { ItemRow } from '@models/item';
import { Fragment } from 'react';

interface Props {
    item: ItemRow;
}

function ItemText({ item }:Props) {
    const {
        salePrice, name, nameEn, nameKo, nameJa,
    } = item;
    const itemName = useGlobalName({
        nameKo, name, nameEn, nameJa,
    });
    const priceUnit = usePriceUnit();
    return (
        <Fragment>
            <NameText as='div' size='s' align='center'>
                {itemName}
            </NameText>
            <Text size='lg' fontWeight='bold'>
                {salePrice.toLocaleString()}{priceUnit}
            </Text>
        </Fragment>
    );
}

const NameText = styled(Text)`
    line-height: 20px;
    margin-top: 4px;
    margin-bottom: 2px;
    white-space: pre-wrap;
    overflow: hidden;
    //max-width: calc(100%  - 52px);
`;

export default ItemText;
